import * as Types from 'Types'
import BaseTreeNode from './BaseTreeNode'
import { store } from '~/Store'
import { InlineKeyEditor } from 'Components'
import { createRoot, TransformationButtons, getCurrentTimeInMillis, getIcon, getIds } from './shared'
import { getRelationkeyLabel } from 'Services/WeaverUtils'
import { setCurrentItem } from 'Actions/explore'

getRelations = (props) ->
  { branches: { currentBranch }} = store.getState()
  relations = await Weaver.MetaQueries.relationsCount({ limit: 99999, branch: currentBranch or 'main' })
  relations.map(({ key, count }) -> relationTreeNode(key, count, props))

relationsTitle = () -> 'Relations'

export relationsRoot = createRoot(relationsTitle, Types.RELATIONS, 'all_relations', getRelations, Types.USERMODES.EXPERT)

export relationTreeNode = (key, count, props) -> {
  key
  path: "all_relations/#{key}"
  selectable: true
  isLeaf: true
  title: (
    <TransformationButtons
      transformComponents={[InlineKeyEditor]}
      type={Types.RELATION_VIEW}
      label="#{getRelationkeyLabel(key)}"
      count={count}
    />
  )
  type: Types.RELATION_VIEW
  hasCtxMenu: false
}

export default {
  [Types.RELATION_VIEW]: (node) ->
    store.dispatch(setCurrentItem({
      id: node.key
      type: Types.RELATION_VIEW
      viewType: Types.VIEWTYPE.ABSTRACT
      ranAt: getCurrentTimeInMillis()
    }))
}
